import { create } from 'zustand';

type ExpenseEditorState = {
  open: boolean;
  /** Null when creating, an expense id when editing. */
  expenseId: string | null;
  openNew: () => void;
  openEdit: (expenseId: string) => void;
  close: () => void;
};

/**
 * The add/edit expense form lives in a modal rather than its own route: on a
 * desktop it is nearly always opened from a list the user wants to stay on.
 */
export const useExpenseEditor = create<ExpenseEditorState>((set) => ({
  open: false,
  expenseId: null,
  openNew: () => set({ open: true, expenseId: null }),
  openEdit: (expenseId) => set({ open: true, expenseId }),
  close: () => set({ open: false, expenseId: null }),
}));
